import service from '../../request/service';
import { Loading } from 'element-gui';
import util from '@/utils/util.js';
import { uploadSignFile, signOpenReportFile } from '@/api/base.js';

let loading; // Loading实例对象
let count; // 签章数量

const getDefaultState = () => {
  return {
    openResultList: [],
    currentReport: '',
    currentReportUrl: '',
    checkAll: false,
    collapseAll: true,
    checkedLists: {},
    collapseList: [],
    loading: false,
    isClick: false,
    notice: '',
    isReCreateReport: false,
    currentIndex:0,
  }
}

const state = getDefaultState()
const getters = {
  checkedListsLength(state) {
    let result = 0;
    state.openResultList &&
      state.openResultList.forEach((item) => {
        for (let p in state.checkedLists) {
          if (item.bidSectionCode === p) {
            result += state.checkedLists[p].length;
          }
        }
      });

    return result;
  },
};
const actions = {
  //上传file到服务器
  uploadToServer({ state, commit, dispatch }, payload) {
    let formData = new FormData();
    formData.append('file1', payload.file, payload.fileName);
    // 上传签章文件
    uploadSignFile(formData).then((res) => {
      if (res.data) {
        console.log('上传成功');
        util.deleteFiles(payload.path);
      } else {
        // 签章文件失败
        commit('NOTICE', {
          text: '签章文件失败，请重新签章',
          type: 'error',
        });
        commit('ISCLICK', false);
        return;
      }
      // 上传签章fileId标识
      signOpenReportFile({
        fileId: res.data,
        userId: JSON.parse(sessionStorage.getItem('obj')).userId,
        reportId: state.currentReport.reportId,
        openbidId: state.currentReport.openbidId,
      }).then(({ code, msg }) => {
        if (code == 200) {
          dispatch('handleGetReportList', false);
        } else {
          commit('NOTICE', {
            text: msg,
            type: 'error',
          });
        }
        commit('ISCLICK', false);
      });
    });
  },
  //上传
  saveToUpload({ dispatch }, payload) {
    if (!!window.ActiveXObject || 'ActiveXObject' in window) {
      console.log(payload.path);
      var ret = util.pathToBase64(payload.path);
      if (ret) var file = util.dataURLtoFile(ret);
      if (file) {
        dispatch('uploadToServer', {
          file,
          path: payload.path,
          fileName: payload.fileName,
        });
      }
    } else {
      console.log('请使用ie浏览器！');
    }
  },
  // 获取报表文件下载URL
  getOpenReportFileUrl({ state, commit }) {
    service
      .post('/report/getOpenReportFileUrl', {
        bidSectionId: state.currentReport.bidSectionId,
        openbidId: state.currentReport.openbidId,
        projectId: state.currentReport.projectId,
        isRemote:
          JSON.parse(sessionStorage.getItem('row'))[0].remote === 'true'
            ? 1
            : 0,
        openStage: sessionStorage.getItem('openbidStage'),
        globalReportId: state.currentReport.reportId,
      })
      .then(({ code, msg, data }) => {
        console.log(data)
        if (code === 200) {
          commit('CURRENTREPORTURL', data);
        } else {
          commit('NOTICE', {
            text: msg,
            type: 'error',
          });
        }
      });
  },
  // 重新生成报表
  handleAgainReport({ state, getters, commit, dispatch }) {
    if (getters.checkedListsLength === 0) {
      commit('NOTICE', {
        text: '请先选择报表',
        type: 'error',
      });
      return;
    }
    let params = [];
    let arr = [];
    state.openResultList &&
      state.openResultList.forEach((item) => {
        for (let p in state.checkedLists) {
          if (item.bidSectionCode === p) {
            state.checkedLists[p].forEach((ele) => {
              arr.push(ele);
            });
          }
        }
      });
    arr.forEach((item) => {
      state.openResultList &&
        state.openResultList.forEach((ele) => {
          ele.reportList.forEach((report) => {
            if (item === report.reportId) {
              console.log(report);
              params.push(report);
            }
          });
        });
    });
    loading = Loading.service({
      lock: true,
      text: '报表正在生成中，请耐心等待...',
      spinner: 'el-icon-loading',
      customClass: 'report-loading',
      background: 'rgba(0, 0, 0, 0.9)',
    });
    commit('LOADING', true);
    commit('ISCLICK', true);
    service
      .post('/report/againOpenReportFile', {
        projectId: state.currentReport.projectId,
        reportFileList: params,
        domainId:
          sessionStorage.getItem('row') &&
          JSON.parse(sessionStorage.getItem('row'))[0].domainId,
      })
      .then(({ code, msg }) => {
        commit('LOADING', false);
        commit('INITCHECKEDLISTS', {});
        commit('ISCLICK', false);

        if (code === 200) {
          loading.close();
          commit('CHECKALL', false);
          // commit('RECREATEREPORT', true);
          dispatch('handleGetReportList', true);
        } else {
          commit('NOTICE', {
            text: msg,
            type: 'error',
          });
          loading.close();
        }
      });
  },
  // 单个签章
  handleSingleSignPDF() {
    let PDFWindow = document.getElementById('DHWPostil1');
    count = PDFWindow.Pdf_GetSealCount();
    PDFWindow.Pdf_Sign();
  },
  // 保存签章
  savePDF({ dispatch, commit }) {
    let PDFWindow = document.getElementById('DHWPostil1');
    if (PDFWindow.Pdf_GetSealCount() != count + 1) {
      console.log('漏章');
      return;
    }
    commit('ISCLICK', true);
    // 存儲路徑
    let fso = new ActiveXObject('Scripting.FileSystemObject');
    let tmppath = fso.GetSpecialFolder(2);
    let fileName = util.uuid() + '.pdf';
    let currentName = tmppath + fileName;
    const isSave = PDFWindow.Pdf_Save_Path(currentName);
    if (isSave == 0) {
      //上传PDF文件至服务器
      console.log('开始上传');
      // 调取上传objectActiveX
      dispatch('saveToUpload', {
        path: currentName,
        fileName: fileName,
      });
    }
  },
  handleGetReportList({ state, dispatch, commit }, boll) {
    // commit('CURRENTREPORT', ''); // 清空生成报表前缓存值
    // commit('OPENRESULTLIST', []);
    if (boll) {
      commit('CURRENTREPORT', ''); // 清空生成报表前缓存值
      commit('OPENRESULTLIST', []);
    }
    commit('RECREATEREPORT', true);
    service
      .post('/report/getOpenReportFileList', {
        domainId: JSON.parse(sessionStorage.getItem('row'))[0].domainId,
        openStage: sessionStorage.getItem('openbidStage'),
        userCode: JSON.parse(sessionStorage.getItem('obj')).userId,
        // userType: JSON.parse(sessionStorage.getItem('obj')).userType,
        userType: JSON.parse(sessionStorage.getItem('obj')).userType == 6 ? 7 : JSON.parse(sessionStorage.getItem('obj')).userType,
      })
      .then((res) => {
        if (res.code == 200) {
          console.log(res);
          let list = res.data.list || [];
          sessionStorage.setItem('openResultList', JSON.stringify(list));
          commit('OPENRESULTLIST', list);
          if (list.length > 0) {
            if(!boll){
              // 保存签章
              console.log(state.currentReport,'state.currentReport');
              console.log(state.isReCreateReport,'state.isReCreateReport');
              console.log(state.currentIndex,'state.isReCreateReport');
              if (!state.currentReport || state.isReCreateReport) {
                let currentReport = list[0].reportList.filter(
                  (item) => item.operate
                )[state.currentIndex];
                if (currentReport) {
                  commit('CURRENTREPORT', currentReport);
                } else {
                  commit('CURRENTREPORT', list[0].reportList[0]);
                }
              }
              dispatch('getOpenReportFileUrl');
            }else{
              commit('RECREATEREPORT', false);
            }
          }
        } else {
          commit('NOTICE', {
            text: res.msg,
            type: 'error',
          });
        }
        commit('ISCLICK', false);
        if (boll) {
          commit('NOTICE', {
            text: '报表生成成功',
            type: 'info',
          });
        } else {
          commit('NOTICE', {
            text: '签章保存成功',
            type: 'info',
          });
        }
      });
  },
};
const mutations = {
  OPENRESULTLIST(state, payload) {
    state.openResultList = payload;
  },
  CURRENTREPORT(state, payload) {
    state.currentReport = payload;
  },
  CURRENTREPORTURL(state, payload) {
    state.currentReportUrl = payload;
  },
  CHECKEDLISTS(state, payload) {
    state.checkedLists = { ...state.checkedLists, ...payload };
  },
  INITCHECKEDLISTS(state, payload) {
    state.checkedLists = payload;
  },
  CHECKALL(state, payload) {
    state.checkAll = payload;
  },
  COLLAPSEALL(state, payload) {
    state.collapseAll = payload;
  },
  LOADING(state, payload) {
    state.loading = payload;
  },
  ISCLICK(state, payload) {
    state.isClick = payload;
  },
  RECREATEREPORT(state, payload) {
    state.isReCreateReport = payload;
  },
  NOTICE(state, payload) {
    state.notice = payload;
    let timer = setTimeout(() => {
      state.notice = '';
      clearTimeout(timer);
    }, 3000);
  },
  COLLAPSElIST(state, payload) {
    state.collapseList = payload;
  },
  CURRENTINDEX(state, payload) {
    console.log(payload,'payloadpayload');
    state.currentIndex = payload;
  },
  resetOpenResultState (state) {
    Object.assign(state, getDefaultState())
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
